import members from '../data/members';
import { useAppContext } from '../context/AppContext';
import copy from '../data/copy';
import assetPath from '../utils/assetPath';
import Seo from '../components/Seo';
import styles from './Members.module.css';

const Members = () => {
  const { language } = useAppContext();
  const t = copy[language].members;

  return (
    <div className={styles.membersView}>
      <Seo
        title={language === 'fr' ? 'Roster' : 'Members'}
        description={t.body}
        image={assetPath('/assets/logo-salty.png')}
        url="https://salty-squad.fr/members"
      />
      <header className={styles.membersHero}>
        <p className="unit">{t.preheading}</p>
        <h1>{t.title}</h1>
        <p>{t.body}</p>
      </header>

      <section className={styles.membersGrid}>
        {members.map((member) => (
          <article key={member.name} className={styles.memberCard}>
            {member.image && (
              <div className={styles.memberPhoto}>
                <img src={member.image} alt={`${member.name} portrait`} />
              </div>
            )}
            <div className={styles.memberDetails}>
              <strong className={styles.memberName}>{member.name}</strong>
              <p className={styles.memberMeta}>{member.role}</p>
              <p>{member.bios[language]}</p>
              <div className={styles.badges}>
                {member.tags.map((tag) => (
                  <span key={`${member.id}-${tag}`} className={styles.badge}>
                    {tag}
                  </span>
                ))}
              </div>
              <div className={styles.memberLinks}>
                {[
                  {
                    key: 'instagram',
                    icon: assetPath('/assets/logo-instagram.webp'),
                    label: member.handle,
                    url: member.instagram,
                  },
                  ...(member.tiktok
                    ? [
                        {
                          key: 'tiktok',
                          icon: assetPath('/assets/logo-tiktok.svg'),
                          label: member.tiktokHandle,
                          url: member.tiktok,
                        },
                      ]
                    : []),
                  ...(member.youtube
                    ? [
                        {
                          key: 'youtube',
                          icon: assetPath('/assets/logo-youtube.svg'),
                          label: member.youtubeHandle,
                          url: member.youtube,
                        },
                      ]
                    : []),
                ].map((social) => (
                  <a key={social.key} href={social.url} target="_blank" rel="noreferrer" className={styles.memberSocial}>
                    <span className="insta-icon insta-icon--small">
                      <img src={social.icon} alt={`${social.key} logo`} />
                    </span>
                    <span>{social.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
};

export default Members;
